import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import {
  matchFrontSizeToFramesInScene,
  matchFrontTypeToFramesInScene
} from 'rangeConfig/smastad/filters/mainMenuProductFilters';
import addFrontStyleToFrame from 'rangeConfig/shared/behaviors/addFrontStyleToFrame';
import changeSmastadFrontBehavior from 'rangeConfig/smastad/behaviors/changeFront';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import { noProductsWithTypesInScene } from 'rangeConfig/shared/rules/noneOptionSelectedRules';
import { sortNestedClusterProductsByHeight } from 'rangeConfig/shared/sorting/sort';
import removeAllDrawersAndHingedDoorsInScene from 'rangeConfig/smastad/behaviors/removeAllDrawersAndHingedDoorsInScene';
import { getQPPImage } from 'products';

export const frontsProductListConfig: ProductListConfig = {
  cluster: ['name', 'design'],
  cardsTitle: 'name',
  cardsSubtitle: 'designText',
  productCardMainImage: getQPPImage,
  behaviors: {
    productClicked: [showDoors, changeSmastadFrontBehavior],
    productDropped: [showDoors, addFrontStyleToFrame]
  },
  productFilters: [matchFrontTypeToFramesInScene, matchFrontSizeToFramesInScene],
  sortOrder: [{ path: 'design' }],
  sortClusteredProducts: sortNestedClusterProductsByHeight,
  categories: [
    {
      id: 'fronts',
      categoryTitle: '',
      products: [
        { path: 'type', value: ProductType.SMASTAD_HINGE_DOOR_ASM },
        { path: 'type', value: ProductType.SMASTAD_DRAWER_ASM }
      ],
      noneOption: {
        title: 'storageone.productListNoDoorsOrDrawersOptionTitle',
        behaviors: { removeProducts: [removeAllDrawersAndHingedDoorsInScene] },
        selected: noProductsWithTypesInScene([
          ProductType.SMASTAD_HINGE_DOOR_ASM,
          ProductType.SMASTAD_DRAWER_ASM
        ])
      }
    }
  ]
};
